const _excluded = ["isLoading", "error", "helperText", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useState } from 'react';
import { TextField } from 'seagull';
import styles from "./OTPField.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function OTPField(_ref) {
  let {
      isLoading,
      error,
      helperText,
      onChange: _onChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [otp, setOtp] = useState('');
  return /*#__PURE__*/_jsx(TextField, _objectSpread({
    className: styles.otpInput,
    type: "text",
    inputMode: "numeric",
    autoComplete: "one-time-code",
    label: "6-digit code",
    placeholder: "",
    value: otp,
    "data-testid": "otp-input",
    inputProps: {
      maxLength: 6
    },
    onChange: async e => {
      const sanitizedOTPValue = e.target.value.slice(0, 6).replace(/\D/g, '');
      setOtp(sanitizedOTPValue);
      _onChange(sanitizedOTPValue, sanitizedOTPValue.length === 6);
    },
    error: error,
    helperText: helperText,
    disabled: isLoading
  }, props));
}